export default __webpack_public_path__ + "static/media/child_protection.57ba7cfd.svg";